/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { HtmlContentLoader, WysiwygStyleWrapper } from '@powdr/components';

import {
  ClockTitle, ClockParts, ClockPart, StyledCountdownClock,
  Value,
  Label,
  Button,
} from './styles';

export const CountdownClock = ({
  className = null,
  title = null,
  countdownEndTimestamp,
  backgroundColor = null,
  countdownFinishedMessage = null,
  relationships = null,
}) => {
  const timestamp = new Date(countdownEndTimestamp).getTime();
  const [timeLeft, setTimeLeft] = useState(timestamp - Date.now());
  const [hasEnded, setHasEnded] = useState(false);

  const getTimeParts = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
      days: String(days).padStart(2, '0'),
      hours: String(hours).padStart(2, '0'),
      minutes: String(minutes).padStart(2, '0'),
      seconds: String(seconds).padStart(2, '0'),
    };
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const remaining = timestamp - now;

      if (remaining <= 0) {
        clearInterval(interval);
        setTimeLeft(0);
        setHasEnded(true);
      } else {
        setTimeLeft(remaining);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [timestamp]);

  return (
    <StyledCountdownClock
      className={className}
      $backgroundColor={backgroundColor}
    >
      <WysiwygStyleWrapper>
        <ClockTitle>{title}</ClockTitle>
        {(hasEnded) ? (
          <HtmlContentLoader html={countdownFinishedMessage?.value} />
        ) : (
          <ClockParts>
            <ClockPart>
              <Value>{getTimeParts(timeLeft).days}</Value>
              <Label>Days</Label>
            </ClockPart>
            <ClockPart>
              <Value>{getTimeParts(timeLeft).hours}</Value>
              <Label>Hours</Label>
            </ClockPart>
            <ClockPart>
              <Value>{getTimeParts(timeLeft).minutes}</Value>
              <Label>Minutes</Label>
            </ClockPart>
            <ClockPart>
              <Value>{getTimeParts(timeLeft).seconds}</Value>
              <Label>Seconds</Label>
            </ClockPart>
          </ClockParts>
        )}
        {(relationships?.button?.buttonLink) && (
          <Button
            className="btn"
            href={relationships?.button?.buttonLink}
            target={relationships?.button?.buttonTarget}
          >
            {relationships?.button?.buttonText}
          </Button>
        )}
      </WysiwygStyleWrapper>
    </StyledCountdownClock>
  );
};

CountdownClock.propTypes = {
  className: PropTypes.string,
  countdownEndTimestamp: PropTypes.string.isRequired,
  title: PropTypes.string,
  backgroundColor: PropTypes.string,
  countdownFinishedMessage: PropTypes.shape({
    value: PropTypes.string,
  }),
  relationships: PropTypes.shape({

  }),
};
